module.exports = __webpack_public_path__ + "img/logo-acc.641fbdf5.png";